import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ServicesService } from '../services.service';
import { Router } from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import swal from 'sweetalert2';
import * as $ from 'jquery';
@Component({
  selector: 'app-session-login',
  templateUrl: './session-login.component.html',
  styleUrls: ['./session-login.component.css']
})

export class SessionLoginComponent implements OnInit {

    isLoginError =  false;
    public login = {'name': '', 'password' : ''};
    loginForm: FormGroup;
    public result;
    @Input() imageId: number;
    @Input() jobId: number;
    @Input() fileName: string;
    @Input() isIndividual: number;

    constructor(private _services: ServicesService, private router: Router) { }

    ngOnInit() {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.loginForm = new FormGroup({
          'name': new FormControl('', [Validators.required]),
          'password': new FormControl('', [Validators.required])
        });

        $('.tb-preloader-wave').fadeOut();
        $('#tb-preloader').delay(200).fadeOut('slow').remove();
    }

    loginUser() {
         this._services.checkLogin(this.loginForm.value).subscribe((data: any) => {
                console.log(data);
             if (data.message == 'unverified') {
                 this.verifyUserAccount(data.email);
             }else {
                 localStorage.setItem('userToken', data.token);

                 this._services.getUserData(data).subscribe((userData: any) => {
                     const myJSON = JSON.stringify(userData.result);
                     // console.log(myJSON);
                     localStorage.setItem('userData', myJSON);
                      // Navigate to the specified URL
                        this.router.navigate(['/jobpphotosproducts'], { 
                            queryParams: { 
                                image_id: this.imageId, 
                                job_id: this.jobId, 
                                file_name: this.fileName, 
                                is_individual: this.isIndividual 
                            } 
                        }).then(() => {
                            // Reload the page after navigating
                            window.location.reload();
                        });
                 });
             }
                 // this.router.navigate([''], { queryParams: { token: data.token } });
             },
         (err: HttpErrorResponse) => {
                  this.isLoginError = true;
             }
         );
    }    

    /* loginUser() {
        this._services.checkLogin(this.loginForm.value).subscribe(
          (data: any) => {
            if (data.message === 'unverified') {
              this.verifyUserAccount(data.email);
            } else {
              localStorage.setItem('userToken', data.token);
              this._services.getUserData(data).subscribe(
                (userData: any) => {
                  const myJSON = JSON.stringify(userData.result);
                  localStorage.setItem('userData', myJSON);
      
                  // Navigate to the specified URL
                  this.router.navigate(['/jobpphotosproducts'], { 
                    queryParams: { 
                      image_id: 135148, 
                      job_id: 327, 
                      file_name: 'AV24A004', 
                      is_individual: 1 
                    } 
                  }).then(() => {
                    // Reload the page after navigating
                    window.location.reload();
                  });
                },
                (error: any) => {
                  console.error('Error fetching user data:', error);
                }
              );
            }
          },
          (error: any) => {
            console.error('Login error:', error);
            this.isLoginError = true;
          }
        );
      } */

    forgetPassword() {
        const that  = this;
        swal({
            title: 'Email',
            text: 'Please Enter Your Registered Email',
            input: 'email',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (email) => {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        if (email === '') {
                            swal.showValidationError(
                                'Please enter a valid email.'
                            );
                        }
                        
                    }, 2000);
                });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((email) => {
            that._services.forgetPassword({'email': email.value}).subscribe((data: any) => {
                    if (data.status === 200) {
                        swal({
                            type: 'success',
                            title: data.msg,
                        });
                    }else {
                        swal({
                            type: 'error',
                            title: data.msg,
                        });
                    }
                },
                (err: HttpErrorResponse) => {
                    this.isLoginError = true;
                }
            );
        });

    }
    verifyUserAccount(emailId){
        const that = this;
        swal({
            title: 'Your Account Is Not Verified!',
            html: 'Verification e-mail has been sent successfully. Please check your Inbox.',
            confirmButtonText : 'Send Verify Mail Again',
            showCancelButton : true,
            type : 'warning',
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                that._services.verifyUserAccount({email : emailId}).subscribe((response: any) => {
                    if (response.status = 200) {
                        swal({
                            type: 'success',
                            title: 'Success',
                            text: 'We have send verification mail on your registered email Id',
                        });
                    }
                }) ;

            }
        });
    }



}


// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/session-login/session-login.component.ts